<template>
  <div class="max-w-xl mx-auto">
    <card v-for="release in releases" :key="release.id" class="mb-5">
      <div class="px-4 py-3 bg-gray-600 dark:bg-gray-300 text-white dark:text-gray-800">
        <h2 class="text-xl font-semibold">
          <a :href="release.html_url" target="_blank" class="text-white dark:text-gray-800">
            {{ release.name }}
          </a>
        </h2>
        <small>{{ formatDateTime(release.published_at) }}</small>
      </div>
      <div v-if="release.assets" class="bg-white dark:bg-gray-700 dark:text-white overflow-x-auto">
        <table>
          <thead>
            <tr>
              <th class="pb-1.5 font-semibold">Asset</th>
              <th class="pb-1.5 text-right font-semibold">Downloads</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="asset in release.assets" :key="asset.id">
              <td class="py-1.5">
                <a :href="asset.browser_download_url" class="font-semibold">{{ asset.name }}</a>
              </td>
              <td class="py-1.5 text-right">{{ formatNumber(asset.download_count) }}</td>
            </tr>
            <tr class="border-b-0">
              <td colspan="2" class="text-right pt-1.5">
                <span class="text-xl font-semibold">
                  = {{ downloads(release) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
  </div>
</template>

<script>
import Card from './Card.vue';
import { formatNumber, formatDateTime } from '../utilities/filters';

export default {
  components: {
    Card,
  },
  props: {
    releases: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      downloads: (release) => formatNumber(
        release.assets.reduce((acc, asset) => acc + asset.download_count, 0),
      ),
      formatDateTime,
      formatNumber,
    };
  },
};
</script>
